import React from "react";
import { Facebook, Twitter, Instagram, ArrowUp } from "lucide-react";
import { motion } from "framer-motion";

const Footer = () => {
  const socialLinks = [
    {
      name: "Facebook",
      icon: Facebook,
      href: "#",
      color: "hover:text-blue-600",
    },
    {
      name: "Twitter",
      icon: Twitter,
      href: "#",
      color: "hover:text-blue-400",
    },
    {
      name: "Instagram",
      icon: Instagram,
      href: "#",
      color: "hover:text-pink-500",
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="bg-gradient-to-br from-[#f8fafc] to-[#f1f5f9] border-t border-gray-200 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-[#e2e8f0]/40"
            style={{
              width: `${Math.random() * 60 + 20}px`,
              height: `${Math.random() * 60 + 20}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -15, 0],
              x: [0, 10, 0],
            }}
            transition={{
              duration: 15 + Math.random() * 20,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 relative z-10">
        <div className="flex flex-col md:flex-row items-start justify-between gap-6">
          {/* Left-aligned Content */}
          <div className="flex flex-col md:flex-row items-start gap-6 md:gap-8">
            {/* Social Icons */}
            {/* <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <motion.a
                    key={index}
                    href={social.href}
                    aria-label={social.name}
                    className={`
                      bg-white border border-gray-200 
                      text-gray-600 ${social.color} p-3 rounded-lg 
                      transition-colors duration-300 flex items-center justify-center
                      w-12 h-12 shadow-sm
                    `}
                    whileHover={{ y: -5 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <IconComponent className="w-5 h-5" />
                  </motion.a>
                );
              })}
            </div> */}

            {/* Privacy Policy */}
            <div className="pt-1">
              <a
                href="#privacy"
                className="text-sm text-gray-600 hover:text-red-500 transition-colors duration-300"
              >
                Privacy Policy
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="flex flex-col items-end gap-4">
            <div className="text-sm text-gray-600 md:text-right">
              Copyright © 2025{" "}
              <span className="text-red-500 font-medium">AAIDAN K</span>. All
              rights reserved.
            </div>
          </div>
        </div>

        {/* Additional decorative element */}
        <motion.div
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-64 h-64 rounded-full bg-red-100/30 blur-3xl z-0"
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
